namespace appn.views.taskTemplates.wizard2 {

    class InitArgs {
        firstToClaimId: string = appn.emptyString;
        allToCompleteId: string = appn.emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;
        appn.tasks.init(_initArgs.firstToClaimId, _initArgs.allToCompleteId, false);
    }
}
